module.exports = __webpack_public_path__ + "static/media/2.edbb2d4e.svg";